enum ConversionSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export { ConversionSize };
